import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MdSyncDisabled } from "react-icons/md";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

function DataSyncError() {
  const { dataSyncTime } = useSelector((state) => state.user);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (!dataSyncTime?.value) {
      setShowError(false);
      return;
    }
    const lastSync = new Date(dataSyncTime.value);
    const now = new Date();
    const diffInHours = (now - lastSync) / (1000 * 60 * 60);
    if (diffInHours >= 24) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  }, [dataSyncTime]);

  if (!showError) return null;

  return (
    <Tooltip>
      <TooltipTrigger>
        {" "}
        <MdSyncDisabled className="w-4 h-4 text-[#D10B00] cursor-pointer" />
      </TooltipTrigger>
      <TooltipContent
        className="bg-[#35424D] text-[#fff] w-[187px] rounded-sm p-2 text-sm"
        align="center"
        side="bottom"
      >
        Sync for today failed. Reach out to the administrator at
        subramani.s@tnqtech.com for support.
      </TooltipContent>
    </Tooltip>
  );
}

export default DataSyncError;
